var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.numberOfMessages == 1)?_c('div',[_c('single-message-display')],1):_c('div',[_c('message-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }